import { useFormik } from "formik";

export default function useDialogFormik({
  initialValues = {},
  onSubmit = () => {},
  validationSchema = undefined,
  enableReinitialize = false,
}) {
  const formikProps = {
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize,
  };
  return useFormik(formikProps);
}
